import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private products: ProductResponseModel[] = [];
  private serverUrl = environment.SERVER_URL;


  constructor(private http: HttpClient) { }

   placeNewOrder(orderData: any): Observable<any> {
    return this.http.post(`${this.serverUrl}/new`, orderData);
  }

  /* GET -> O singură Comandă */
  getSingleOrder(orderId: number)
  {
    return this.http.get<ProductResponseModel[]>(this.serverUrl + 'orders/' + orderId).toPromise();
  }

}


interface ProductResponseModel {
  id: number;
  title: string;
  description: string;
  price: number;
  quantityOrdered: number;
  image: string;
}